define('modules/form/image_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  './form_item_view',

  'modules/image_picker/image_picker_view',

  'text!./image_template.html',
  'text!modules/form/media_fact_connection/media_fact_connection_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  FormItemView,
  ImagePickerView,
  template,
  media_fact_connection_template
) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      this.listenTo(this.model, 'change', this.renderMediaFactConnection);

      FormItemView.prototype.initialize.apply(this, options);

      var value = {};

      value[this.model.get('name')] =
        this.model.get('file_id') || this.model.get('value') || null;
      this.dataModel.set(value);
      this.dataModelAttributesOriginal = _.cloneDeep(this.dataModel.attributes);

      this.render();
      this.renderMediaFactConnection();
      this.setupDragEvents();
    },
    template: _.template(template),
    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(
        this.media_fact_connection_template(this.model.attributes)
      );
      return this;
    },
    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },
    media_fact_connection_template: _.template(media_fact_connection_template),
    events: {
      'change [type=file]': 'handleInput',
      'click .js-pick-image': 'showImagePicker',
      'click .js-remove-media': 'removeImage',
    },

    setupDragEvents: function () {
      var self = this;
      $('body').on(
        'drag dragstart dragend dragover dragenter dragleave drop',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
        }
      );

      this.$('.image-field')

        .on('dragover dragenter', function (e) {
          var target = e.currentTarget;
          target.classList.add('is-dragover');
        })

        .on('dragleave dragend drop', function (e) {
          var target = e.currentTarget;
          target.classList.remove('is-dragover');
        })

        .on('drop', function (e) {
          var files = e.originalEvent.dataTransfer.files;

          if (files[0].type.match('image.*')) {
            self.processImage(files[0]);
          }
        });
    },
    processImage: function (image) {
      // Task #9237 - Check for multiple "." in file name
      if (image.name.match(/\./g).length > 1) {
        Backbone.trigger('showError', 'fileUploadError', null);
        return;
      }
      var self = this;
      var reader = new FileReader();
      reader.onload = function (img) {
        console.log(img);
        var thumbnail =
          '<img class="thumbnail" src="' + img.target.result + '">';
        self.$('.image-preview').html(thumbnail);
        self.$('.form-field').addClass('has-image has-media is-uploading');
      };

      reader.readAsDataURL(image);
      this.uploadImage(image);
    },
    handleInput: function (e) {
      this.processImage(e.originalEvent.target.files[0]);
    },
    removeImage: function (e) {
      e.preventDefault();

      var property = this.model.get('name');

      this.dataModel.set(property, null);

      if (this.model.get('media_fact_connection') === 'Connected') {
        this.model.set('media_fact_connection', 'WillDisconnect');
      }
      // Reset to 'Connected' if user changes back to the original value.
      else if (
        this.model.get('media_fact_connection') === 'WillDisconnect' &&
        null == this.dataModelAttributesOriginal[property]
      ) {
        this.model.set('media_fact_connection', 'Connected');
      }

      this.$('.media-preview').html('');
      this.$('.form-field').removeClass('has-media');
    },
    uploadImage: function (image) {
      var self = this;
      // TODO: change url and add some better feedback
      if (this.model.get('upload_url')) {
        this.url = session.get('apiBaseUrl') + this.model.get('upload_url');
      } else {
        this.url = session.get('apiUrl') + 'comments/files';
      }
      var formdata = new FormData();
      formdata.append(image.name, image);
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open('POST', this.url, true);

      xhr.addEventListener('load', function (e) {
        self.$('.form-field').removeClass('is-uploading');
        var response = JSON.parse(xhr.responseText);
        if (response.success) {
          var property = self.model.get('name');

          self.dataModel.set(property, response.id);

          if (self.model.get('media_fact_connection') === 'Connected') {
            self.model.set('media_fact_connection', 'WillDisconnect');
          }
          // Reset to 'Connected' if user changes back to the original value.
          else if (
            self.model.get('media_fact_connection') === 'WillDisconnect' &&
            response.id === self.dataModelAttributesOriginal[property]
          ) {
            self.model.set('media_fact_connection', 'Connected');
          }
        } else {
          self.$('.form-field').addClass('has-error');
        }
      });

      xhr.send(formdata);
    },
    showImagePicker: function () {
      var imagePicker,
        pickFile = function (file) {
          if (file.get('preview_url')) {
            var property = this.model.get('name');

            this.dataModel.set(property, file.get('preview_url'));

            if (this.model.get('media_fact_connection') === 'Connected') {
              this.model.set('media_fact_connection', 'WillDisconnect');
            }
            // Reset to 'Connected' if user changes back to the original value.
            else if (
              this.model.get('media_fact_connection') === 'WillDisconnect' &&
              file.get('preview_url') ===
                this.dataModelAttributesOriginal[property]
            ) {
              this.model.set('media_fact_connection', 'Connected');
            }

            var thumbnail =
              '<img class="thumbnail" src="' + file.get('preview_url') + '">';
            this.$('.image-preview').html(thumbnail);
            this.$('.form-field').addClass('has-image has-media');
          }

          imagePicker.modal.close();
        }.bind(this);

      imagePicker = new ImagePickerView({
        limit: 60,
        onSelect: pickFile,
      });
    },
  });
  return View;
});

